import React from "react";

import { AuthedRoute } from "../../helpers/authed-route";
import { route } from "../../../application/domain/routing/named-route";
import { ProcManagementProcedureListContainer } from "./procedure-list";
import {
  ProcManagementProcedureEditContainer,
  RedirectToProcManagementProcedureEditContainer,
} from "./procedure-edit";
import { ProcManagementProcedureCreateContainer } from "./procedure-create";
import { ProcManagementPlaceListContainer } from "./place-list";
import { ProcManagementPlaceCreateContainer } from "./place-create";
import {
  ProcManagementPlaceEditContainer,
  RedirectToProcManagementPlaceEditContainer,
} from "./place-edit";
import { StatusValue } from "../../../application/domain/proc-management";
import { REG_EXP_STR_FOR_UUID } from "../../../utils/url-utils";
import { ProcManagementProcedureTagListContainer } from "./procedure-tag-list";
import { ProcManagementConfigEdit } from "./config-edit";

export const ProcManagementR = {
  // /procedures
  ProcedureList: route({
    path: "/proc-management/procedures",
    link: (args: { page?: number; q?: string; statuses?: StatusValue[] }) => {
      const queries = [];
      if (typeof args.q === "string") {
        queries.push(`q=${args.q}`);
      }
      if (typeof args.page === "number") {
        queries.push(`page=${args.page}`);
      }
      if (args.statuses && Array.isArray(args.statuses)) {
        queries.push(`status=${args.statuses.join(",")}`);
      }

      return `/proc-management/procedures${
        queries.length > 0 ? `?${queries.join("&")}` : ""
      }`;
    },
    component: ProcManagementProcedureListContainer,
  }),
  ProcedureCreate: route({
    path: "/proc-management/procedures/new",
    component: ProcManagementProcedureCreateContainer,
  }),
  ProcedureDetail: route({
    path: `/proc-management/procedures/:procId(${REG_EXP_STR_FOR_UUID})`,
    link: (args: { procId: string }) => {
      return `/proc-management/procedures/${args.procId}`;
    },
    component: RedirectToProcManagementProcedureEditContainer,
  }),
  ProcedureEdit: route({
    path: `/proc-management/procedures/:procId(${REG_EXP_STR_FOR_UUID})/edit`,
    link: (args: { procId: string }) => {
      return `/proc-management/procedures/${args.procId}/edit`;
    },
    component: ProcManagementProcedureEditContainer,
  }),

  // /places
  PlaceList: route({
    path: "/proc-management/places",
    link: (args: { page?: number }) =>
      `/proc-management/places${
        typeof args.page === "number" ? `?page=${args.page}` : ""
      }`,
    component: ProcManagementPlaceListContainer,
  }),
  PlaceCreate: route({
    path: "/proc-management/places/new",
    component: ProcManagementPlaceCreateContainer,
  }),
  PlaceDetail: route({
    path: `/proc-management/places/:placeId(${REG_EXP_STR_FOR_UUID})`,
    link: (args: { placeId: string }) => {
      return `/proc-management/places/${args.placeId}`;
    },
    component: RedirectToProcManagementPlaceEditContainer,
  }),
  PlaceEdit: route({
    path: `/proc-management/places/:placeId(${REG_EXP_STR_FOR_UUID})/edit`,
    link: (args: { placeId: string }) => {
      return `/proc-management/places/${args.placeId}/edit`;
    },
    component: ProcManagementPlaceEditContainer,
  }),

  // procedure_tags
  ProcedureTagList: route({
    path: "/proc-management/procedure-tags",
    link: (args: { page?: number }) =>
      `/proc-management/procedure-tags${
        typeof args.page === "number" ? `?page=${args.page}` : ""
      }`,
    component: ProcManagementProcedureTagListContainer,
  }),

  // config
  ConfigEdit: route({
    path: "/proc-management/config",
    link: () => `/proc-management/config`,
    component: ProcManagementConfigEdit,
  }),
};

export const ProcManagementRoute: React.FC = () => {
  return (
    <>
      {Object.entries(ProcManagementR).map(([key, route]) => {
        return (
          <AuthedRoute
            exact
            path={route.forRouter.path}
            component={route.forRouter.component}
            key={`ProcManagementRoute-${key}`}
          />
        );
      })}
    </>
  );
};
